// extracted by mini-css-extract-plugin
export var cartContainer = "_jj-4";
export var gray = "_jj-1";
export var itemContainer = "_jj-2";
export var itemDetails = "_jj-3";
export var strong = "_jj-0";